<template>
  <div class="slider inline">
    <div class="item" :class="[{active: current(possibleValue)}, $mq, {bottom: possibleValue.longLabel}, {TA:isTestAchat}]" @click="$emit('input', index)" v-for="(possibleValue, index) in possibleValues" :key="possibleValue.label">
      <span class="label">{{ possibleValue.label }}</span>
      <h1 class="long-label" v-if="possibleValue.longLabel && current(possibleValue)">{{ possibleValue.longLabel }}</h1>
    </div>
    <!-- <div class="action content-centered" :class="$mq" @click="decrease()">
      <SvgIcon icon="decrease" class="icon content-centered" fill />
    </div>
    <h1 class="label">{{ current.label }}</h1>
    <div class="action content-centered" :class="$mq" @click="increase()">
      <SvgIcon icon="increase" class="icon content-centered" fill />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters("subscription", ["isTestAchat"])
    // current() {
    //   return this.possibleValues[this.value];
    // },
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    possibleValues: {
      type: Array,
      required: true,
    },
  },
  methods: {
    decrease() {
      let value = this.value;

      if (this.value > 0) {
        this.$emit("input", this.value - 1);
      }
    },
    increase() {
      if (this.value < this.possibleValues.length - 1) {
        this.$emit("input", this.value + 1);
      }
    },
    current(value) {
      return this.possibleValues[this.value] === value;
    }
  },
};
</script>

<style lang="scss" scoped>
.slider {
  .item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    width: 35px;
    height: 35px;
    border: 1px solid $grey;
    border-radius: 50%;
    background: $white;
    color: $grey;
    box-shadow: 5px 10px 10px #4d545a12;

    &.bottom {
      margin-bottom: 20px;

      .label {
        font-size: 0.6rem!important;
      }
    }

    .label {
      color: $black!important;
      font-size: 0.8rem!important;
      font-weight: 600;
    }

    &.active {
      background: $clearYellow;
      color: $yellow;
      border: 1px solid $yellow;
      position: relative;

      .label {
        position: absolute;
        display: block;
      }
      
      &.bottom::after {
        position: absolute;
        bottom: -5px;

        content: " ";
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 5px solid $yellow;
      }
    }

    .long-label {
      display: block;
      position: absolute;
      color: $black;
      top: 35px;
      // width: 150px!important;
      text-align: center!important;
      margin: 5px 0!important;
      white-space: nowrap;
      font-size: 0.8rem!important;
      padding: 0!important;
      border-radius: 0!important;
      background: none!important;
    }

    &.mobile:last-child .long-label {
      right: 20px;
    }

    &.mobile:first-child .long-label {
      left: 20px;
    }
  }
}

.TA {
  .item {
    &.active {
      border: 1px solid $pink;
      background-color: $pink;
      .label {
        color: $white!important;
      }

      &.bottom::after {
        border-top: 5px solid $orange;
      }
    }
  }
}
</style>


 <style lang="scss" scoped>
// .slider {
//   position: relative;
//   display: flex;
//   flex-direction: row;

//   .label {
//     text-align: left!important;
//     display: block;
//     // flex: 1;
//     margin: 5px 0!important;
//     margin-left: 10px!important;
//     font-size: 0.8rem!important;
//     padding: 0!important;
//     border-radius: 0!important;
//     background: none!important;
//   }

//   .action {
//     .icon {
//       cursor: pointer;
//       width: 35px !important;
//       height: 35px !important;
//       border: 1px solid $yellow !important;
//       box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
//       border-radius: 50%;
//       color: $black;
//       font-size: 1.3rem;
//       background: $clearYellow !important;
//       box-shadow: 5px 10px 10px #4d545a12;


//       &>:first-child {
//         margin-top: 0!important;
//       }
//     }
//   }

//   .icon {
//     font-size: 3rem;
//     width: 70px;
//     height: 70px;
//     border-radius: 20%;
//     color: $black;
//     background: linear-gradient(136deg, #fdcb47, #fcc648);
//     box-shadow: 5px 10px 10px #4d545a12;
//   }

//   .count {
//     // cursor: default;
//     // position: absolute;
//     // left: calc(50% - 20px);
//     // padding: 2px 10px;
//     // background: $black;
//     // border-radius: 50px;
//     // color: $white;
//     // font-size: 0.7rem;
//     // top: 62px;
//   }
// }
// </style>


// WEBPACK FOOTER //
// src/components/Form/SimulationFields/SliderField.vue